import React, { useEffect, useState } from "react";

import { useTranslation } from "utils";

import { BLANK_PRODUCT } from "consts";

import { Icon, Link } from "components";

import { FertilizerForm } from "pages/app/modules/components/Fertilizer/FertilizerForm";

export const FertilizerBaselineYear = ({ existingProducts, fertilizers, forms, year, onDeleteProduct, onUpdate }) => {
  const { t } = useTranslation(["modules"]);
  const defaultProducts = existingProducts || [BLANK_PRODUCT()];
  const [products, setProducts] = useState(defaultProducts);

  useEffect(() => {
    forms.current[year] = forms.current[year].slice(0, products.length);
  }, [forms, products, year]);

  const addNewProduct = () => {
    const updatedProducts = [...products, BLANK_PRODUCT()];
    setProducts(updatedProducts);
    onUpdate("fertilizer", year, updatedProducts);
  };

  const deleteProduct = (index) => {
    const productsCopy = [...products];
    productsCopy.splice(index, 1);
    setProducts(productsCopy);
    onDeleteProduct("fertilizer", products[index].id);
    onUpdate("fertilizer", year, productsCopy);
  };

  const updateProduct = (index, v) => {
    const productsCopy = [...products];
    productsCopy[index] = { id: productsCopy[index].id, ...v };
    setProducts(productsCopy);
    onUpdate("fertilizer", year, productsCopy);
  };

  return (
    <div className="margin-bottom-400">
      <div className="baseline-year-header-row">
        <h2>{year}</h2>
      </div>

      {products.length ? (
        products.map((product, index) => (
          <div key={product.key || product.id}>
            <FertilizerForm
              fertilizers={fertilizers}
              forms={forms}
              index={index}
              product={product}
              year={year}
              onDelete={deleteProduct}
              onUpdate={updateProduct}
            />
          </div>
        ))
      ) : (
        <p className="margin-bottom-200">{t("bauEntryDrawer.fertilizer.noneApplied")}</p>
      )}
      <Link dataTestId="fertilizer-add-product" onClick={addNewProduct}>
        {t("bauEntryDrawer.fertilizer.addProduct")} <Icon iconName="klim/plus" className="icon inline" />
      </Link>
    </div>
  );
};
